import React, { Component } from 'react';
import { withRouter } from 'react-router';

import styled from 'styled-components';
import { Grid, Row, Image } from 'react-bootstrap';
import { DayNightButton, CenteredCol, TimeMark } from '../StyledPrimitives/StyledPrimitives';

const FullWidthButton = styled(DayNightButton)`
    display: block;
    width: 90%;
    margin: 10px auto;
    text-align: center;
    border-width: 4px;
`;

const CenteredImage = styled(Image)`
    margin: 0 auto;
    border-width: 2px;
    border-style: ${props => props.hasBorder ? 'solid' : 'none'};
    border-color: ${props => props.isDay ? 'lightblue' : 'darkgray'};
`;

class Job extends Component {

    handleClicked() {
        this.props.history.push({
            pathname: '/games/' + this.props.id,
            state: {isDay: this.props.isDay} 
        });
    }

    render() {
        return (
            <FullWidthButton isDay={this.props.isDay} onClick={this.handleClicked.bind(this)}>
                <Grid fluid>
                    <Row>
                        <CenteredCol>
                            <h2>{this.props.job} <TimeMark>{this.props.years}</TimeMark></h2>
                            <h5>{this.props.typeAndPlatform}</h5>
                            <h5>as {this.props.title}</h5>
                            <h5>with {this.props.collaborators}</h5>
                        </CenteredCol>
                    </Row>
                    <Row>
                        <CenteredCol>
                            <CenteredImage responsive isDay={this.props.isDay} hasBorder={this.props.image.hasBorder}
                                src={process.env.PUBLIC_URL + '/images/' + this.props.image.url} 
                                alt={this.props.job + 'Screenshot'}>
                            </CenteredImage>
                        </CenteredCol>
                    </Row>
                </Grid>
            </FullWidthButton>
        );
    }
}

export default withRouter(Job);


// WEBPACK FOOTER //
// ./src/components/Job/Job.js